import _ from "lodash";
import React from "react";
import moment from "moment";
import shortUuid from "short-uuid";
import { AiOutlineUndo } from "react-icons/ai";
import { useReport } from "../contexts/reports/hooks";
import {
  VscAdd,
  VscCheck,
  VscCircleSlash,
  VscChevronRight,
} from "react-icons/vsc";

const UsersReportsTable = ({ reports, handleUpdateReportStatus }) => {
  const {
    actions: { selectReport },
  } = useReport();

  return (
    <div className="py-6 overflow-x-auto flex-grow">
      <div className="inline-block w-full overflow-hidden">
        <table className="w-full min-w-full leading-normal table-fixed">
          <thead>
            <tr>
              <th className="w-1/5 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Nombre
              </th>
              <th className="w-1/5 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Email/Teléfono
              </th>
              <th className="w-1/6 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Empresa
              </th>
              <th className="w-1/6 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Reportes
              </th>
              <th className="w-1/6 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Usuario desde
              </th>
              <th className="w-1/5 px-5 py-3 text-left text-xs font-semibold text-gray-600 tracking-wider">
                Bloquear
              </th>
            </tr>
          </thead>
          <tbody>
            {_.values(reports).map(
              ({ content, content_type, count, status, _id }) => {
                const user = content;
                return content_type === "User" ? (
                  <tr key={`user__${shortUuid.generate()}`}>
                    <td className="px-5 py-5 border-b border-gray-200">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 w-10 h-10">
                          <img
                            className={`w-full h-full rounded-full`}
                            src={user.profile_photo}
                            alt={user.first_name}
                          />
                        </div>
                        <div className="ml-3">
                          <p className="break-all ">
                            {`${user.first_name} ${user.last_name}`}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200">
                      <p className="break-all">
                        {user.number ? user.number.data.number : user.email}
                      </p>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200">
                      <p className="break-all">{user.current_company}</p>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200">
                      <div
                        onClick={() =>
                          selectReport({
                            _id,
                            count,
                            status,
                            content,
                            content_type,
                          })
                        }
                        className="w-full inline-flex items-center text-blue-500"
                      >
                        <p className="cursor-pointer mr-4">{count} reportes</p>
                        <VscChevronRight className="text-2xl cursor-pointer" />
                      </div>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200">
                      <p className="break-all whitespace-no-wrap">
                        {!!user.created_at
                          ? _.upperFirst(moment(user.created_at).fromNow())
                          : "Ninguna"}
                      </p>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200">
                      {status === "pending" ? (
                        <>
                          <div
                            onClick={() => {
                              handleUpdateReportStatus(_id, "ignored");
                            }}
                            className="inline-flex items-center mr-6  cursor-pointer"
                          >
                            <VscCheck className="text-gray-500 mr-1 text-xl" />
                            <p className="">Archivar</p>
                          </div>
                          <div
                            onClick={() => {
                              handleUpdateReportStatus(_id, "blocked");
                            }}
                            className="inline-flex items-center  cursor-pointer"
                          >
                            <VscCircleSlash className="text-gray-500 mr-1 text-xl" />
                            <p className="">Bloquear</p>
                          </div>
                        </>
                      ) : (
                        <div
                          onClick={() => {
                            handleUpdateReportStatus(_id, "pending");
                          }}
                          className="inline-flex items-center  cursor-pointer"
                        >
                          {status === "blocked" ? (
                            <VscAdd className="text-gray-500 mr-1 text-xl" />
                          ) : (
                            <AiOutlineUndo className="text-gray-500 mr-1 text-xl" />
                          )}
                          <p className="">
                            {status === "blocked"
                              ? "Desbloquear"
                              : "Desarchivar"}
                          </p>
                        </div>
                      )}
                    </td>
                  </tr>
                ) : null;
              }
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersReportsTable;
